import { ChainId, CHAIN_NAMES, LOCAL_CHAINS, TEST_CHAINS } from '../constants';

function etherscanNetworkPrefix(chainId) {
  switch (chainId) {
    case ChainId.Mainnet:
      return "";

    case ChainId.Ropsten:
    case ChainId.Kovan:
    case ChainId.Rinkeby:
    case ChainId.Goerli:
      return getChainName(chainId).toLocaleLowerCase() + '.';
  }
}

export function getExplorerAddressLink(address, chainId) {
  switch (chainId) {
    case ChainId.Mainnet:
    case ChainId.Ropsten:
    case ChainId.Kovan:
    case ChainId.Rinkeby:
    case ChainId.Goerli:
      return "https://".concat(etherscanNetworkPrefix(chainId), "etherscan.io/address/").concat(address);

    case ChainId.BSC:
      return "https://bscscan.com/address/".concat(address);

    case ChainId.xDai:
      return "https://blockscout.com/poa/xdai/address/".concat(address, "/transactions");

    case ChainId.Polygon:
      return "https://explorer-mainnet.maticvigil.com/address/".concat(address, "/transactions");

    case ChainId.Mumbai:
      return "https://explorer-mumbai.maticvigil.com/address/".concat(address, "/transactions");

    case ChainId.Harmony:
      return "https://explorer.harmony.one/address/".concat(address);

    case ChainId.Moonriver:
      return "https://blockscout.moonriver.moonbeam.network/address/".concat(address, "/transactions");
  }
}
export function getExplorerTransactionLink(transactionHash, chainId) {
  switch (chainId) {
    case ChainId.Mainnet:
    case ChainId.Ropsten:
    case ChainId.Kovan:
    case ChainId.Rinkeby:
    case ChainId.Goerli:
      return "https://".concat(etherscanNetworkPrefix(chainId), "etherscan.io/tx/").concat(transactionHash);

    case ChainId.BSC:
      return "https://bscscan.com/tx/".concat(transactionHash);

    case ChainId.xDai:
      return "https://blockscout.com/poa/xdai/tx/".concat(transactionHash, "/internal-transactions");

    case ChainId.Polygon:
      return "https://explorer-mainnet.maticvigil.com/tx/".concat(transactionHash, "/internal-transactions");

    case ChainId.Mumbai:
      return "https://explorer-mumbai.maticvigil.com/tx/".concat(transactionHash, "/internal-transactions");

    case ChainId.Harmony:
      return "https://explorer.harmony.one/tx/".concat(transactionHash);

    case ChainId.Moonriver:
      return "https://blockscout.moonriver.moonbeam.network/tx/".concat(transactionHash, "/internal-transactions");
  }
}
export function getChainName(chainId) {
  return CHAIN_NAMES[chainId];
}
export function isTestChain(chainId) {
  return TEST_CHAINS.includes(chainId);
}
export function isLocalChain(chainId) {
  return LOCAL_CHAINS.includes(chainId);
}